import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import queryString from 'query-string';

import BaseFilter, { FilterTypeEnum } from 'components/base/BaseFilter';
import {
  EarningRuleLinkedCampaign,
  EarningRuleRewardType,
  EarningRuleType,
  SEGMENT_TYPE,
} from 'config/CustomEnums';

import { ArrayStringData } from 'utils';

function Filter({
  segmentList,
  levelList,
  backAction = () => { }
}) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search.slice(1));
  const searchType = parsedSearch['type'] || '';
  const searchRewardType = parsedSearch['reward_type'] || '';
  const searchCampaignType = parsedSearch['linked_campaign_type'] || '';
  const searchTargetCustomer = parsedSearch['target_customer'] || '';
  const searchLevels = parsedSearch['levelsIn'] || '';
  const searchStaticSegments = parsedSearch['staticSegmentsIn'] || '';
  const searchDynamicSegments = parsedSearch['dynamicSegmentsIn'] || '';

  const [type, setType] = useState(searchType);
  const [rewardType, setRewardType] = useState(
    ArrayStringData(searchRewardType),
  );
  const [linkedCampaignType, setLinkedCampaignType] = useState(
    ArrayStringData(searchCampaignType),
  );
  const [targetCustomer, setTargetCustomer] = useState(searchTargetCustomer);
  const [levels, setLevels] = useState(ArrayStringData(searchLevels));
  const [dynamicSegments, setDynamicSegments] = useState(ArrayStringData(searchDynamicSegments));
  const [staticSegments, setStaticSegments] = useState(ArrayStringData(searchStaticSegments));

  const [staticSegmentList, dynamicSegmentList] = useMemo(() => {
    if (!segmentList?.length > 0) {
      return [[], []]
    }
    const staticSegment = segmentList?.filter(item => item?.segmentType === SEGMENT_TYPE.STATIC) || []
    const dynamicSegment = segmentList?.filter(item => item?.segmentType === SEGMENT_TYPE.DYNAMIC) || []
    return [staticSegment, dynamicSegment]
  }, [segmentList])


  const content = [
    {
      title: 'Type',
      data: [
        { pk: EarningRuleType.qrCodeScanning, name: 'QR Code' },
        { pk: EarningRuleType.gpsCheckIn, name: 'GPS' },
        { pk: EarningRuleType.memberReferral, name: 'Referral' },
        { pk: EarningRuleType.generalPurchase, name: 'Purchase' },
        { pk: EarningRuleType.newMember, name: 'New Member' },
        { pk: EarningRuleType.birthday, name: 'Birthday' },
        { pk: EarningRuleType.fillingForm, name: 'Webhook' },
        { pk: EarningRuleType.levelUpgrade, name: 'Level Upgrade' },
      ],
      value: type,
      setValue: setType,
      component: FilterTypeEnum.singleChoice,
    },
    {
      title: 'Reward type',
      data: [
        { name: 'Coupons', pk: EarningRuleRewardType.coupons },
        { name: 'Points', pk: EarningRuleRewardType.points },
        { name: 'Stamps', pk: EarningRuleRewardType.stamps },
      ],
      value: rewardType,
      setValue: setRewardType,
      component: FilterTypeEnum.choice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Linked campaign type',
      data: [
        {
          name: 'Stamp campaign',
          pk: EarningRuleLinkedCampaign.stampCampaign,
        },
        {
          name: 'Earning campaign',
          pk: EarningRuleLinkedCampaign.earningCampaign,
        },
      ],
      value: linkedCampaignType,
      setValue: setLinkedCampaignType,
      component: FilterTypeEnum.choice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Target customer',
      data: [
        {
          name: 'Dynamic segment',
          pk: 'dynamicSegmentsIn',
          subComponment: {
            data: dynamicSegmentList,
            value: dynamicSegments,
            setValue: setDynamicSegments,
            component: FilterTypeEnum.choice,
            className: 'filter-list-items-sub-area',
          },
        },
        {
          name: 'Static segment',
          pk: 'staticSegmentsIn',
          subComponment: {
            data: staticSegmentList,
            value: staticSegments,
            setValue: setStaticSegments,
            component: FilterTypeEnum.choice,
            className: 'filter-list-items-sub-area',
          },
        },
        {
          name: 'Level',
          pk: 'levelsIn',
          subComponment: {
            data: levelList,
            value: levels,
            setValue: setLevels,
            component: FilterTypeEnum.choice,
            className: 'filter-list-items-sub-area',
          },
        },
      ],
      value: targetCustomer,
      setValue: setTargetCustomer,
      component: FilterTypeEnum.singleChoiceTargetCustomer,
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

const mapPropsToState = (state) => ({
  segmentList: state.segments.notPagedAllList,
  levelList: state.levels.levelList,
});

export default connect(mapPropsToState)(Filter);
